/* eslint-disable import/no-unresolved */

import { MetaHelmet } from 'layouts/Helmet/Helmet';
import { useDevice } from 'hooks/useResponsive';
import BookingPageMobile from './BookingMobile';
import BookingPageWeb from './Booking';

export default function Booking() {
  const { isMobile } = useDevice();

  return (
    <div id="booking_top">
      <MetaHelmet title={'Booking'} companyName={'ZealCurtains'} />
      {isMobile ? <BookingPageMobile /> : <BookingPageWeb />}
    </div>
  );
}
